import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import {
  ContentWrapper as Content,
  CancellationTitle,
  MainWrapper,
  UnderstandButton,
  SubTitle,
  PolicyText,
} from './policyOverlay.styles';
import { Overlay } from '../overlay';
import { renderWhenNotNil, renderWhenTrue } from '../../utils/rendering';
import messages from './policyOverlay.messages';
import { CancellationPolicy } from '../cancellationPolicy';
import { AnimatedOverlay } from '../animatedOverlay';
import { HashRoute } from '../hashRoute';
import { DotSeparatedTitle } from '../dotSeparatedTitle';
import { HASHES } from '../../../routes/routes';

export class PolicyOverlay extends PureComponent {
  static propTypes = {
    experience: PropTypes.object,
    isPolicyVisible: PropTypes.bool,
    isPolicyStandalone: PropTypes.bool,
    showPolicy: PropTypes.func,
    hidePolicy: PropTypes.func,
    intl: PropTypes.object,
    cancellationPolicy: PropTypes.object,
  };

  get headerTitle() {
    const { intl, experience } = this.props;
    const base = experience.name;
    const cancelLabel = intl.formatMessage(messages.overlayTitle);

    return <DotSeparatedTitle mainText={base} secondaryText={cancelLabel} />;
  }

  handleOpen = () => this.props.showPolicy();
  handleClose = () => this.props.hidePolicy();

  renderButton = () => (
    <UnderstandButton label={this.props.intl.formatMessage(messages.understand)} onClick={this.handleClose} />
  );

  renderContent = () => {
    const {
      text,
      firstParagraphTitle,
      firstParagraphText,
      secondParagraphTitle,
      secondParagraphText,
    } = this.props.cancellationPolicy;
    const { refund } = this.props.experience;

    return (
      <Fragment>
        <HashRoute
          hashName={HASHES.cancellationPolicy}
          isActive={this.props.isPolicyVisible && !this.props.isPolicyStandalone}
          onLeave={this.handleClose}
          onEnter={this.handleOpen}
        />
        <AnimatedOverlay
          visible={this.props.isPolicyVisible && !isNil(this.props.experience)}
          disableAnimation={this.props.isPolicyStandalone}
        >
          <Overlay title={this.headerTitle} onClose={this.props.isPolicyStandalone ? null : this.handleClose}>
            <Content>
              <CancellationTitle>{this.props.intl.formatMessage(messages.cancellationTitle)}</CancellationTitle>
              <MainWrapper>
                <PolicyText>{text}</PolicyText>

                <CancellationPolicy refund={refund} />

                <SubTitle>{firstParagraphTitle}</SubTitle>
                <PolicyText>{firstParagraphText}</PolicyText>

                <SubTitle>{secondParagraphTitle}</SubTitle>
                <PolicyText>{secondParagraphText}</PolicyText>
              </MainWrapper>
              {renderWhenTrue(this.renderButton)(!this.props.isPolicyStandalone)}
            </Content>
          </Overlay>
        </AnimatedOverlay>
      </Fragment>
    );
  };

  render = () => renderWhenNotNil(this.renderContent)(this.props.experience);
}
